import {setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils'

export enum StoreMenuItem {
    Membership = 'membership',
    Expansions = 'expansions',
    Maps = 'maps',
    Colors = 'colors',
    Avatars = 'avatars',
    Coins = 'coins',
    Rewards = 'rewards',
}

export const STORE_SIDEBAR_BUTTON_IDS = {
    membership: 'm-store-button-membership',
    expansions: 'm-store-button-expansions',
    maps: 'm-store-button-maps',
    colors: 'm-store-button-colors',
    avatars: 'm-store-button-avatars',
    coins: 'm-store-button-coins',
    rewards: 'm-store-button-rewards',
}

export const STORE_SIDEBAR_DIV_IDS = {
    membership: 'm-store-membership',
    expansions: 'm-store-expansion',
    maps: 'm-store-maps',
    colors: 'm-store-colors',
    avatars: 'm-store-avatars',
    coins: 'm-store-coins',
    rewards: 'm-store-referral',
}

export class UIMStoreSidebarController {
    private readonly membershipButton: HTMLDivElement
    private readonly expansionsButton: HTMLDivElement
    private readonly mapsButton: HTMLDivElement
    private readonly colorsButton: HTMLDivElement
    private readonly avatarsButton: HTMLDivElement
    private readonly coinsButton: HTMLDivElement
    private readonly rewardsButton: HTMLDivElement
    private readonly membershipDiv: HTMLDivElement
    private readonly expansionsDiv: HTMLDivElement
    private readonly mapsDiv: HTMLDivElement
    private readonly colorsDiv: HTMLDivElement
    private readonly avatarsDiv: HTMLDivElement
    private readonly coinsDiv: HTMLDivElement
    private readonly rewardsDiv: HTMLDivElement
    private readonly allDivs: HTMLDivElement[] = []
    private readonly allButtons: HTMLDivElement[] = []

    constructor() {
        this.membershipButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Membership]) as HTMLDivElement
        this.expansionsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Expansions]) as HTMLDivElement
        this.avatarsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Avatars]) as HTMLDivElement
        this.colorsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Colors]) as HTMLDivElement
        this.coinsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Coins]) as HTMLDivElement
        this.mapsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Maps]) as HTMLDivElement
        this.rewardsButton = document.getElementById(STORE_SIDEBAR_BUTTON_IDS[StoreMenuItem.Rewards]) as HTMLDivElement
        this.membershipDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Membership])[0] as HTMLDivElement
        this.expansionsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Expansions])[0] as HTMLDivElement
        this.avatarsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Avatars])[0] as HTMLDivElement
        this.colorsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Colors])[0] as HTMLDivElement
        this.coinsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Coins])[0] as HTMLDivElement
        this.mapsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Maps])[0] as HTMLDivElement
        this.rewardsDiv = document.getElementsByClassName(STORE_SIDEBAR_DIV_IDS[StoreMenuItem.Rewards])[0] as HTMLDivElement
        this.allDivs = [this.membershipDiv, this.expansionsDiv, this.avatarsDiv, this.colorsDiv, this.coinsDiv, this.mapsDiv, this.rewardsDiv]

        this.allButtons = [this.membershipButton, this.expansionsButton, this.avatarsButton, this.colorsButton, this.coinsButton, this.mapsButton, this.rewardsButton]

        this.setButtonActions()
        this.openDefaultStorePage()
    }

    private setButtonActions() {
        setElementOnClick(this.membershipButton, this.getClickAction(this.membershipDiv, this.membershipButton))
        setElementOnClick(this.expansionsButton, this.getClickAction(this.expansionsDiv, this.expansionsButton))
        setElementOnClick(this.avatarsButton, this.getClickAction(this.avatarsDiv, this.avatarsButton))
        setElementOnClick(this.colorsButton, this.getClickAction(this.colorsDiv, this.colorsButton))
        setElementOnClick(this.coinsButton, this.getClickAction(this.coinsDiv, this.coinsButton))
        setElementOnClick(this.mapsButton, this.getClickAction(this.mapsDiv, this.mapsButton))
        setElementOnClick(this.rewardsButton, this.getClickAction(this.rewardsDiv, this.rewardsButton))
    }

    private getClickAction(divElement: HTMLDivElement, currentButton: HTMLDivElement): () => void {
        return () => {
            this.allDivs.forEach((container) => {
                container.style.display = 'none'
            })
            divElement.style.display = ''

            this.allButtons.forEach((button: HTMLDivElement) => {
                button.classList.remove('active')
            })
            currentButton.classList.add('active')
        }
    }

    openDefaultStorePage(newHash?: string) {
        const hash = newHash ?? window.location.hash
        switch(hash) {
            case '#membership':
                this.getClickAction(this.membershipDiv, this.membershipButton)()
                break
            case '#expansions':
                this.getClickAction(this.expansionsDiv, this.expansionsButton)()
                break
            case '#colors':
                this.getClickAction(this.colorsDiv, this.colorsButton)()
                break
            case '#avatars':
                this.getClickAction(this.avatarsDiv, this.avatarsButton)()
                break
            case '#maps':
                this.getClickAction(this.mapsDiv, this.mapsButton)()
                break
            case '#coins':
                this.getClickAction(this.coinsDiv, this.coinsButton)()
                break
            case '#rewards':
                this.getClickAction(this.rewardsDiv, this.rewardsButton)()
                break
            default:
                this.openMembership()
                break
        }
    }

    openMembership() {
        this.allDivs.forEach((container) => container.style.display = 'none')
        this.getClickAction(this.membershipDiv, this.membershipButton)()
    }

    openCoins() {
        this.allDivs.forEach((container) => container.style.display = 'none')
        this.getClickAction(this.coinsDiv, this.coinsButton)()
    }

    openRewards() {
        this.allDivs.forEach((container) => container.style.display = 'none')
        this.getClickAction(this.rewardsDiv, this.rewardsButton)()
    }
}
